import { SongsService } from './../api/services/songs-service';
import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { ScrollService, ScrollParams, AlbumsService, SearchService, BasicSearchParams } from '../api';
import * as _ from 'lodash';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
  selector: 'app-artist',
  templateUrl: './albums.component.html',
  styleUrls: ['./albums.component.css']
})
export class AlbumsComponent implements OnInit, OnDestroy {
  private title: string = '';
  private albums: Array<any>;
  private scrollParams = new ScrollParams();
  private searchTerm: string = '';
  private lastTerm: string = '';
  private scrollSubscriber = null;
  private totalRecords: number = 0; // for search see all count
  @BlockUI() blockUI: NgBlockUI;
  enableElasticSearch: boolean = false;

  constructor(private albumService: AlbumsService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef,
  private scrollService: ScrollService, private router: Router, private searchService: SearchService, private songService: SongsService) {
    this.albums = new Array<any>();
    this.route.queryParams.subscribe((queryParams: any) => {
      this.searchTerm = queryParams.q;
    });
    if (this.route.snapshot.data['title']) {
      this.title = this.route.snapshot.data['title'];
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe((queryParams: any) => {
      this.searchTerm = queryParams.q;
      this.blockUI.start('Loading, please wait...');
      this.getAlbums();
    });
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getAlbums());
  }

  getAlbums() {
    let collectionsnamesdata = [];
    this.scrollService.toggleProgressBar(true);
    if (this.lastTerm !== this.searchTerm) {
      this.resetScrollParams();
      this.lastTerm = this.searchTerm;
      this.albums = new Array<any>();
    }
    let params = new BasicSearchParams(false, true, false);
    let quickSearch:string = 'yes';
    this.songService.getCollectionsfromdb(this.searchTerm, quickSearch, this.scrollParams.page).toPromise().then((res) => {
      collectionsnamesdata = res['collections'];
      this.totalRecords = res['totalCount'];
      if(!res['collections'] && this.enableElasticSearch) {
        this.searchService.getSearchResults(this.searchTerm, params, this.scrollParams).then((res: any) => {
          this.totalRecords = res.total;
          if(res.total > 0) {
            if (res.data.album.length > 0) {
              res.data.album.forEach((arrayItem) => {
    
                arrayItem._source._type = "artist"
                arrayItem._source.active = 1;
                this.albums.push(arrayItem._source);
              });
              this.scrollParams.page++;
              this.albums = _.uniqBy(this.albums, 'id');
    
            }
          }
          this.scrollService.toggleProgressBar(false);
          this.cdRef.detectChanges();
          this.blockUI.stop();
    
        }).catch((err) => {
          this.blockUI.stop();
        });
      }
      this.albums = [].concat(this.albums, collectionsnamesdata)
      this.albums = _.uniqBy(this.albums, 'id');
      this.scrollService.toggleProgressBar(false);
      if(res['collections'].length > 0) {
        this.scrollParams.page++;
      }
      this.cdRef.detectChanges();
      this.blockUI.stop();
    });
  }

  resetScrollParams() {
    this.scrollParams = new ScrollParams();
  }

  handleSearch(event) {
    this.searchTerm = event.searchTerm;
    let navigationExtras: NavigationExtras = {
      relativeTo: this.route,
      queryParams: { 'q': this.searchTerm },
    };
    this.getAlbums();
    this.router.navigate([], navigationExtras)
  }

  ngOnDestroy() {
    if (this.scrollSubscriber != null) {
      this.scrollSubscriber.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/albums/albums.component.ts